(function () {
  const LINK_CLASS = 'pw-moon-size-guide';

  function getModalToOpen() {
  const raincoatModal = document.querySelector('[data-pw-size-modal="raincoat-four-feet"]');
  const shoesModal   = document.querySelector('[data-pw-size-modal="waterproof_shoes"]');
  const defaultModal = document.querySelector('[data-pw-size-modal="default"]');
  const anyModal     = document.querySelector('[data-pw-size-modal]');

  return raincoatModal || shoesModal || defaultModal || anyModal || null;
}

  function openModal() {
    const modal = getModalToOpen();
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeOpenModal() {
    const modal = document.querySelector('.pw-size-modal.is-open');
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  // Shadow DOM / engellenen click için sağlam link yakalama
  function findLinkFromEvent(e) {
    const path = (typeof e.composedPath === 'function') ? e.composedPath() : [];
    for (const el of path) {
      if (el && el.classList && el.classList.contains(LINK_CLASS)) return el;
    }
    return e.target && e.target.closest ? e.target.closest('.' + LINK_CLASS) : null;
  }

  function findMoonRoot() {
    return (
      document.querySelector('[class*="moon"][class*="bundle"]') ||
      document.querySelector('[class*="moon-bundle"]') ||
      document.querySelector('[class*="moon"]') ||
      null
    );
  }

  // Link ekle (ama duplicate yapma)
  function injectLinks() {
    const root = findMoonRoot();
    if (!root) return;

    // sayfada zaten en az 1 link varsa tekrar ekleme (çoğalma olmasın)
    if (root.querySelector('.' + LINK_CLASS)) return;

    const cards = root.querySelectorAll(
      '[class*="offer"], [class*="card"], [class*="bundle-item"], [class*="bundleOption"], .moonbundle-offer-wrapper'
    );
    if (!cards.length) return;

    cards.forEach((card) => {
      if (card.querySelector('.' + LINK_CLASS)) return;

      const link = document.createElement('a');
      link.href = '#';
      link.className = LINK_CLASS;
      link.textContent = 'Beden Rehberi';

      card.appendChild(link);
    });
  }

  // Observer throttle
  let t = null;
  function scheduleInject() {
    if (t) return;
    t = setTimeout(() => {
      t = null;
      injectLinks();
    }, 200);
  }

  function bindOnce() {
    if (document.documentElement.dataset.pwMoonSizeBound) return;
    document.documentElement.dataset.pwMoonSizeBound = '1';

    // Açma: capture + composedPath (engellenmesin)
    const openHandler = function (e) {
      const link = findLinkFromEvent(e);
      if (!link) return;
      e.preventDefault();
      openModal();
    };

    document.addEventListener('pointerup', openHandler, true);
    document.addEventListener('click', openHandler, true);

    // Kapatma: capture
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pw-size-close]')) return;
      e.preventDefault();
      closeOpenModal();
    }, true);

    // ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeOpenModal();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindOnce();
    injectLinks();

    const obs = new MutationObserver(scheduleInject);
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
